import React from "react";
import Foundation from "@microsoft/fast-components-foundation-react";
import { canUseCssGrid, classNames } from "@microsoft/fast-web-utilities";
export class Page extends Foundation {
    constructor() {
        super(...arguments);
        this.handledProps = {
            managedClasses: void 0,
            margin: void 0,
            maxWidth: void 0,
            cssGridPropertyName: void 0,
        };
    }
    /**
     * Renders the Page markup
     */
    render() {
        return React.createElement("div", Object.assign({}, this.generateAttributes()), this.props.children);
    }
    generateAttributes() {
        const columns = `${this.props.margin} minmax(0, ${this.props.maxWidth}) ${this.props.margin}`;
        const attributes = Object.assign(Object.assign({}, this.unhandledProps()), { className: super.generateClassNames(classNames(this.props.managedClasses.page)) });
        return Object.assign(Object.assign({}, attributes), { style: Object.assign({ display: this.props.cssGridPropertyName === "grid"
                    ? "grid"
                    : this.props.cssGridPropertyName === "-ms-grid"
                        ? "-ms-grid"
                        : canUseCssGrid()
                            ? "grid"
                            : "-ms-grid", gridTemplateColumns: columns, msGridColumns: columns }, attributes.style) });
    }
}
Page.displayName = "Page";
Page.defaultProps = {
    margin: "minmax(5vw, 1fr)",
    maxWidth: "1600px",
    managedClasses: {},
};
export * from "./page.props";
